/* eslint-disable no-use-before-define */
/*
 * The lightweight player can be turned on using the query string:
 *
 *   lightweight=true
 *
 * Lightweight only works for media only presentations, and they must have their
 * height and width and template specified in the query string, so the full
 * query string you need to add is along the lines of:
 *
 *   t=mo&height=450&width=600&&lightweight=true
 *
 * The lightweight player should only be used for embedding video, and only
 * when that video is public. It should not be used for password protected or
 * user group restricted presentations.
 *
 */
(function() {
  var reflectorLookupService = require('../../components/common/ReflectorLookupService/ReflectorLookupService');
  var EnvironmentInitialState = require('../../app/shared/modules/environment/src/vue/stores/environment.store').EnvironmentInitialState;

  // TODO: Does not yet deal with restricted presentations. They currently s
  // how a default thumbnail, and the video does not play on iOS or
  // BlackBerrys.

  var videoId = 'html5video';
  var html5UserAgents = /iPad|iPhone|iPod/;
  var blackBerryUserAgent = /BlackBerry/;
  var chromeUserAgent = '/Chrome/';

  var thumbnailEndPoint = KV.serverPath + '/kulu/{packageGuid}/thumbnail';
  var mp4VideoEndPoint = KV.serverPath + '/kulu/{packageGuid}/mediaasset?profile=MP4Video';
  var viewStatsEndPoint = KV.serverPath + '/viewStats';

  var blankImageUrl = KV.staticContentCdnBase + '/graphics/spacer.gif';
  var playIconUrl = KV.staticContentCdnBase + '/graphics/player/play-icon.png';
  var playIconHoverUrl = KV.staticContentCdnBase + '/graphics/player/play-icon-hover.png';
  var playIconHeight = 72;
  var playIconWidth = 72;
  var loadingUrl = KV.staticContentCdnBase + '/graphics/player/loading_background.png';
  var loadingAnimatonUrl = KV.staticContentCdnBase + '/graphics/player/loading_animation.gif';
  var loadingIconHeight = 72;
  var loadingIconWidth = 72;

  var init = function() {
    var pguidStartIndex = location.pathname.indexOf('/view/');
    var pguid = location.pathname.substring(pguidStartIndex + '/view/'.length);
    var qs = parseQueryString(location.search.substring(1));

    qs.pguid = pguid;

    if (shouldLoadLightweight(qs)) {
      loadLightWeightPlayer(qs);
    } else {
      updateLoadingImage(qs);
      loadPlayer();
    }
  };

  var shouldLoadLightweight = function(qs) {
    // This will become more complex once we want to the lightweight
    // player to load automatically.
    return qs.lightweight === 'true';
  };

  var loadLightWeightPlayer = function(qs) {
    var thumbnailUrl = thumbnailEndPoint.replace('{packageGuid}', qs.pguid);

    // Width and height are required in the url (or the current size of the page is used)
    var width = qs.width || document.body.clientWidth;
    var height = qs.height || document.body.clientHeight;

    // We initialise the play and loading icons with blank images
    // to avoid an issue in Firefox where an image placeholder would
    // sometime be visible.

    var domString = [
      '<div id="loadingMessage" style="height: ', height, 'px; width: ', width, 'px; margin: 0 auto; position: relative; cursor: pointer; background: black;">',
      '<img id="thumbnail" src="', thumbnailUrl, '" style="position: absolute; display: none;"  />',
      '<img id="play-icon" src="', blankImageUrl, '" style="position: absolute; left: ', Math.round((width - playIconWidth) / 2), 'px; top: ', Math.round((height - playIconHeight) / 2), 'px; width: ' + playIconWidth + 'px; height: ' + playIconHeight + 'px;"  />',
      '<img id="loading-icon" src="', blankImageUrl, '" style="position: absolute; left: ', Math.round((width - loadingIconWidth) / 2), 'px; top: ', Math.round((height - loadingIconHeight) / 2), 'px; width: ' + loadingIconWidth + 'px; height: ' + loadingIconHeight + 'px; display: none;"  />',
      '<img id="loading-animation" src="', loadingAnimatonUrl, '" style="position: absolute; left: ', Math.round((width - loadingIconWidth) / 2), 'px; top: ', Math.round((height - loadingIconHeight) / 2), 'px; display: none;"  />',
      '</div>'
    ].join('');

    // Hide scrollbars to avoid un-needed scrollbars appearing in Chrome
    // Must only run in Chrome because it stops IE7 working
    if (navigator.userAgent.match(chromeUserAgent)) {
      document.body.style.overflow = 'hidden';
    }
    document.body.innerHTML = domString;

    loadPlayImages();
    bindEvents(qs);

    loadImage(thumbnailUrl, function(image) {
      updateThumbnail(image, width, height);
    });

    // So that the full player knows to autoplay
    KV.lightweight = true;
  };

  var loadPlayImages = function() {
    var preloadHoverImg = new Image();
    preloadHoverImg.src = playIconHoverUrl;

    var playIcon = document.getElementById('play-icon');
    setPngImage(playIcon, playIconUrl);

    var loadingIcon = document.getElementById('loading-icon');
    setPngImage(loadingIcon, loadingUrl);
  };

  var bindEvents = function(qs) {
    var playIcon = document.getElementById('play-icon');
    var container = document.getElementById('loadingMessage');
    container.onmouseover = function() {
      setPngImage(playIcon, playIconHoverUrl);
    };
    container.onmouseout = function() {
      setPngImage(playIcon, playIconUrl);
    };
    container.onclick = function() {
      container.onclick = null;
      loadPlayerFromLightweight(qs);
    };

    // Send player load and player viewed data to the server
    window.onbeforeunload = sendPercentageViewed;
    window.onunload = sendPercentageViewed;
  };

  /*
   * View stats are now sent from multiple locations, so if this needs to be
   * changed remember to update PackagePlayer.js and the Widgets project!
   */
  var haveSentPercentageViewed = false;
  var sendPercentageViewed = function() {
    if (haveSentPercentageViewed) {
      return;
    }

    // If there is no video element, or the video has not been loaded
    // then default to sending 0%.
    // This makes the server register a player load instead of a play.
    var time = 0;
    var duration = 100;

    var video = document.getElementById(videoId);
    if (video) {
      time = video.currentTime;
      duration = video.duration;
    }

    var pv = Math.max(0, Math.min(100, Math.round((time / duration) * 100))) || 0;

    var pvUrl = viewStatsEndPoint +
      '?pg=' + encodeURIComponent(qs.pguid) +
      '&pv=' + encodeURIComponent(pv) +
      (document.referrer !== '' ? '&r=' + encodeURIComponent(document.referrer) : '') +
      (qs.ri ? '&ri=' + encodeURIComponent(qs.ri) : '') +
      (qs.e ? '&e=' + encodeURIComponent(qs.e) : '') +
      (qs.cb ? '&cb=' + encodeURIComponent(qs.cb) : '') +
      (qs.cbp ? '&cbp=' + encodeURIComponent(qs.cbp) : '') +
      '&n=' + new Date().getTime() + Math.round(Math.random() * 100000);

    synchronousAjax(pvUrl);
    haveSentPercentageViewed = true;
  };

  var updateThumbnail = function(image, width, height) {
    var media = {
      left: 0,
      top: 0,
      width: width,
      height: height,
      ratio: image.height / image.width
    };

    media.height = Math.round(media.width * media.ratio);

    if (media.height > height) {
      media.height = height;
      media.width = Math.round(media.height / media.ratio);
    }

    media.left = Math.round((width - media.width) / 2);
    media.top = Math.round((height - media.height) / 2);

    var thumbnail = document.getElementById('thumbnail');
    thumbnail.style.left = media.left + 'px';
    thumbnail.style.top = media.top + 'px';
    thumbnail.style.width = media.width + 'px';
    thumbnail.style.height = media.height + 'px';
    thumbnail.style.display = 'block';
  };

  var showLoading = function() {
    document.getElementById('play-icon').style.display = 'none';
    document.getElementById('loading-icon').style.display = 'block';
    document.getElementById('loading-animation').style.display = 'block';
  };

  var loadPlayerFromLightweight = function() {
    // Re-instate the scrollbars for Chrome
    // Must only run in Chrome because it stops IE7 working
    if (navigator.userAgent.match(chromeUserAgent)) {
      document.body.style.overflow = 'auto';
    }

    // Blackberry doesn't do html5 video tag
    // so we redirect straight to the video
    if (navigator.userAgent.match(blackBerryUserAgent)) {
      window.top.location = getMp4VideoUrl(qs.pguid);

    } else if (navigator.userAgent.match(html5UserAgents)) {
      loadHtml5Player(qs);

    } else {
      // Remove event handler that send view stats as the full player
      // has it's own.
      window.onbeforeunload = null;
      window.onunload = null;

      showLoading();

      // Allow the loading indicator time to appear
      setTimeout(function() {
        loadPlayer();
      }, 0);
    }
  };

  var loadHtml5Player = function(qs) {
    var thumbnailUrl = thumbnailEndPoint.replace('{packageGuid}', qs.pguid);
    var videoUrl = getMp4VideoUrl(qs.pguid);

    // Width and height are required in the url (or the current size of the page is used)
    var width = qs.width || document.body.clientWidth;
    var height = qs.height || document.body.clientHeight;

    // Get height and width?
    var domString = '<video id="' + videoId + '" style="width: ' + width + 'px; height: ' + height + 'px; margin: 0 auto; display: block; background: black;" controls poster="' + thumbnailUrl + '" src="' + videoUrl + '"></video>';

    document.body.innerHTML = domString;

    var video = document.getElementById(videoId);
    video.addEventListener('ended', sendPercentageViewed, false);

    // The works because we are inside a touch event on iOS
    video.play();
  };

  var getMp4VideoUrl = function(guid) {
    return mp4VideoEndPoint.replace('{packageGuid}', guid);
  };

  var updateLoadingImage = function(qs) {
    if (qs.textload) {
      document.getElementById('loadingMessageContent').innerHTML = '<span class=\"message\">Loading...</span>';
      return;
    }

    document.getElementById('loadingImage').style.display = 'inline';
  };

  var loadPlayer = function() {
    reflectorLookupService.setServerPath(KV.serverPath);
    reflectorLookupService.performLookup(loadPlayerScripts);
  };

  var loadPlayerScripts = function() {
    loadScript(KV.application, function() {
      loadScript(KV.properties, function() {

        if (typeof Application !== 'undefined') {
          KV.defer(function() {
            AppProperties.OmitRootControl = true;
            Application.run(function() {
              return new PlayerUI(AppProperties.PlayerControlName, KV.preview);
            });
          });

          window.onunload = function() {
            if (typeof Application !== 'undefined') {
              Application.cleanup();
            }
          };
        }
      });
    });
  };

  /*
   * Utility Functions
   */

  var loadScript = function(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {  //IE
      script.onreadystatechange = function() {
        if (script.readyState === 'loaded' ||
          script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {  //Others
      script.onload = function() {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  var parseQueryString = function(queryString) {
    var qs = {};

    var pairs = queryString.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      qs[parts[0]] = parts[1];
    }

    return qs;
  };

  var synchronousAjax = function(url) {
    var ajax;
    if (window.XMLHttpRequest) {
      ajax = new XMLHttpRequest();
    } else {
      ajax = new ActiveXObject('Microsoft.XMLHTTP');
    }
    if (ajax) {
      ajax.open('GET', url, false);
      ajax.send(null);
      return ajax.responseText;
    } else {
      return false;
    }
  };

  var setPngImage = function(element, url) {
    if (/MSIE 6/.test(navigator.userAgent)) {
      element.src = blankImageUrl;
      element.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + url + "',sizingMethod='scale')";
    } else {
      element.src = url;
    }
  };

  var loadImage = function(url, callback) {
    var image = new Image();
    image.onload = function() {
      callback(image);
    };
    image.src = url;
  };

  /*
   * Start the ball rolling...
   */
  if ('newrelic' in window) {
    var configService = {
      getCustomerConfig: function() {
        return {
          get: function () {
            return false;
          },
        };
      },
      get: function () {
        return false;
      },
    };
    var environment = new EnvironmentInitialState(configService, window);

    window.newrelic.setCustomAttribute('userAgentOSVersion', environment.platform.osVersion);
    window.newrelic.setCustomAttribute('PlayerVersion', '1');
  }

  init();
})();
